export default function AboutData() {
  return {
    disclaimer: "* Certain term life insurance policies are subject to full medical underwriting and are not available for immediate coverage."
   }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LongTermDisability/EtradeAboutData.js